import React, { useState, useRef, useEffect } from "react";
import ContentBlock from "../containers/ContentBlock";

type ConfigProps = {
    title: string;
    children: React.ReactNode;
};

export default function ConfigContainer({ title, children }: ConfigProps) {
    const [collapsed, setCollapsed] = useState(false);
    const containerRef = useRef<HTMLDivElement>(null);
    const [height, setHeight] = useState<string | number>('auto');

    useEffect(() => {
        const el = containerRef.current;
        if (!el) return;

        if (collapsed) {
            const currentHeight = el.scrollHeight;
            setHeight(currentHeight);
            requestAnimationFrame(() => setHeight(0));
        } else {
            setHeight(0);
            requestAnimationFrame(() => {
                const scrollHeight = el.scrollHeight;
                setHeight(scrollHeight);
            });
        }
    }, [collapsed]);

    const handleTransitionEnd = () => {
        if (!collapsed) setHeight('auto');
    };

    return (
        <ContentBlock
            title={title}
            label={collapsed ? "+" : "-"}
            onClick={() => setCollapsed(!collapsed)}
        >
            <div
                className="config-block overflow-hidden transition-all duration-500 ease-in-out flex justify-between gap-1"
                style={{ height }}
                onTransitionEnd={handleTransitionEnd}
                ref={containerRef}
            >
                <div className="config-inputs flex flex-col gap-1">
                    {children}
                </div>
            </div>
        </ContentBlock>
    );
}
